























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import PagesService, { FolderListItemModel } from '@/services/cms/PagesService';
import { Option } from '@/helpers/Interfaces';
import merge from 'lodash/merge';

@Component({
    name: 'widget-menu-settings'
})
export default class MenuSettings extends Vue
{
    @Prop() private value!: any;

    private folders: FolderListItemModel[] = [];
    private defaults: any = {
        folder: null,
        fromLevel: 1,
        toLevel: 1,
        expand: 1
    };

    protected get form(): any
    {
        return this.value;
    }

    protected get levels(): Option<number>[]
    {
        return new Array(10).fill(null).map((value, index) =>
        {
            return {value: index + 1, text: (index + 1).toString()};
        });
    }

    async created()
    {
        this.form.settings = merge(this.defaults, this.form.settings);

        await this.loadFolders();
    }

    async loadFolders()
    {
        try
        {
            this.folders = (await PagesService.getFolders(this.form.websiteId, this.form.locale)).items.map(p => p.result);
        }
        catch (ex)
        {
            this.folders = [];
            this.$log.debug(ex);
        }
    }

    @Watch('form.settings', {deep: true})
    onSettingsChanged(value: any)
    {
        this.$emit('input', this.form);
    }
}
